import arMessages from './messages/ar.json';
import caMessages from './messages/ca.json';
import es419Messages from './messages/es_419.json';
import esarMessages from './messages/es_AR.json';
import esesMessages from './messages/es_ES.json';
import frMessages from './messages/fr.json';
import heMessages from './messages/he.json';
import idMessages from './messages/id.json';
import ititMessages from './messages/it_IT.json';
import kokrMessages from './messages/ko_KR.json';
import plMessages from './messages/pl.json';
import ptbrMessages from './messages/pt_BR.json';
import ptptMessages from './messages/pt_PT.json';
import ruMessages from './messages/ru.json';
import thMessages from './messages/th.json';
import trtrMessages from './messages/tr_TR.json';
import ukMessages from './messages/uk.json';
import zhcnMessages from './messages/zh_CN.json';

const messages = {
  ar: arMessages,
  ca: caMessages,
  'es-419': es419Messages,
  fr: frMessages,
  he: heMessages,
  id: idMessages,
  'ko-kr': kokrMessages,
  pl: plMessages,
  'pt-br': ptbrMessages,
  ru: ruMessages,
  th: thMessages,
  uk: ukMessages,
  'zh-cn': zhcnMessages,
  'es-ar': esarMessages,
  'es-es': esesMessages,
  'it-it': ititMessages,
  'pt-pt': ptptMessages,
  'tr-tr': trtrMessages,
};

export default messages;
